import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useLocation } from 'react-router-dom'

import { MonetaryVerificationsTopBarProps } from './MonetaryVerificationsTopBar.types'
import { Badge, CardDashboard, Flex, Tabs } from '@percent/lemonade'
import styles from './MonetaryVerificationsTopBar.module.scss'
import { statusMap } from '@percent/admin-dashboard/constants/statusMap'

export function MonetaryVerificationsTopBar({
  id,
  organizationName,
  activeTab,
  setActiveTab,
  status
}: Readonly<MonetaryVerificationsTopBarProps>) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()

  const handleChange = (newTab: string) => {
    setActiveTab(newTab)
    navigate(newTab)
  }

  useEffect(() => {
    if (location) {
      setActiveTab(`${location.pathname}`)
    }
  }, [location, setActiveTab])

  return (
    <CardDashboard
      title={
        <Flex direction="row" gap={8} align="center">
          {organizationName}
          {status && (
            <Badge variant={statusMap[status].variant} icon={statusMap[status].icon}>
              {t(statusMap[status].text)}
            </Badge>
          )}
        </Flex>
      }
      className={styles.topBarContainer}
      data-testid="monetary-verifications-topbar"
    >
      <Tabs
        activeTab={activeTab}
        onChangeTab={handleChange}
        items={[{ key: `/monetary-verifications/${id}`, label: t('typography.requestDetails') }]}
      />
    </CardDashboard>
  )
}
